/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkPillarRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkPillarRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkPillarRequest>): WellArchitectedFrameworkPillarRequest {
        let obj = Object.assign(new WellArchitectedFrameworkPillarRequest(), model);
        WellArchitectedFrameworkPillarRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkPillarRequest>): WellArchitectedFrameworkPillarRequest {
        if (!model) return null;
        return WellArchitectedFrameworkPillarRequest.newInstance(<WellArchitectedFrameworkPillarRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkPillarRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkPillarRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkPillarRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkPillarRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pillars) {
            for (let val of this.pillars) {
                models.WellArchitectedFrameworkPillar.fixupPrototype(val);
            }
        }
    }

    /**
     * Pillars to process
     */
    pillars: Array<models.WellArchitectedFrameworkPillar>;

}
